module.exports = __webpack_public_path__ + "static/media/podio-2nd.17216f5f.png";